import React, { useEffect, useState } from 'react';
import { Bell, Gift, Heart, UserPlus, MessageSquare, Sparkles, Trophy, CalendarHeart } from 'lucide-react';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';

const ICONS = {
  gift_received: Gift,
  follow: UserPlus,
  like: Heart,
  message: MessageSquare,
  level_up: Sparkles,
  achievement: Trophy,
  date_invite: CalendarHeart,
  date_invite_response: CalendarHeart,
  welcome: Sparkles,
};

export default function NotificationsPage() {
  const [list, setList] = useState([]);
  const { markNotificationsRead } = useAuth();

  useEffect(() => {
    let alive = true;
    api.get('/notifications').then(r => { if (alive) setList(r.data); }).catch(() => {});
    // Instant-clear the badge in the bottom nav + mark all as read on the server (best-effort)
    markNotificationsRead?.();
    return () => { alive = false; };
  }, [markNotificationsRead]);

  return (
    <div className="space-y-4" data-testid="notifications-page">
      <h1 className="font-display font-bold text-2xl md:text-3xl">Notifications</h1>
      {list.length === 0 ? (
        <div className="rounded-2xl bg-[#161622] border border-white/10 p-10 text-center">
          <Bell className="mx-auto text-white/30" size={42} />
          <div className="font-display font-semibold text-lg mt-3">All caught up</div>
          <div className="text-white/50 text-sm mt-1">You&apos;ll see new activity here.</div>
        </div>
      ) : (
        <div className="space-y-2">
          {list.map((n) => {
            const Icon = ICONS[n.type] || Bell;
            return (
              <div
                key={n.id}
                data-testid={`notif-${n.id}`}
                className={`flex items-start gap-3 rounded-2xl border p-4 ${n.read ? 'bg-white/3 border-white/5' : 'bg-fuchsia-500/8 border-fuchsia-400/25'}`}
              >
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${n.read ? 'bg-white/5 text-white/40' : 'bg-fuchsia-500/20 text-fuchsia-200'}`}>
                  <Icon size={18} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-white/90">{n.text}</div>
                  <div className="text-[10px] uppercase tracking-wider text-white/40 mt-1">
                    {new Date(n.created_at).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
                  </div>
                </div>
                {!n.read && <span className="mt-2 w-2 h-2 rounded-full bg-fuchsia-400" />}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
